import React from 'react';
import PropTypes from 'prop-types';

const ErrorAlert = ({children}) => (
    <div className="alert alert-danger" role="alert">
        {children}
    </div>
);

ErrorAlert.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ErrorAlert;



// WEBPACK FOOTER //
// ./src/components/ErrorAlert.js